import axios from "axios";
import { getKeycloak } from "../services/keycloakService";

const isAdmin = () => {
  const kc = getKeycloak();
  return kc?.tokenParsed?.groups?.includes("project42-admin") || false;
};

async function getImage(imageUrl) {
  return await axios
    .get(imageUrl, { responseType: "blob" })
    .then(async (response) => {
      return URL.createObjectURL(response.data);
    })
    .catch(() => {
      return "/assets/images/default.webp";
    });
}

export default { isAdmin, getImage };
